import React from 'react';
import classNames from 'classnames';
import { Listing } from 'models/Listing';
import { Link } from 'react-router-dom';
import utils, { checkIsTierPremium, isNewListing } from 'utils';
import StatusBadge from '../StatusBadge';
import ListingPrices from 'components/ListingPrices';
import ListingCardThumbnail from 'components/ListingCardThumbnail';
import ListingLocation from 'components/ListingLocation';
import ListingActions from '../../../../components/ListingActions';

import './ListingCard.styles.scss';
import './ListingCard.styles.responsive.scss';

type ListingCardProps = {
  className?: string;
  listing: Listing;
  onWatchlisted: (isWatchlisted: boolean) => void;
};

const ListingCard: React.FC<ListingCardProps> = (props) => {
  const { className, listing, onWatchlisted } = props;

  const {
    listingTitle,
    location,
    dealLocation,
    revenue,
    industry,
    gallery,
    createdAt,
    slugName,
    businessDescription,
    EBITDA,
    averageStockValue,
    askingPriceSelect,
    stockAtValue,
    type,
    currency,
    tier,
    listingContact,
    amount,
    amountFrom,
    amountTo,
    amountRequiredVisibleInfo,
    amountFromRequiredVisibleInfo,
    amountToRequiredVisibleInfo,
    revenueRequiredVisibleInfo,
    EBITDARequiredVisibleInfo,
    averageStockValueRequiredVisibleInfo,
  } = listing;

  const classes = classNames('listing-card', className);

  const firmLogo = listingContact?.firmLogo?.url;

  const isListingPremium = checkIsTierPremium(tier);

  const redirectionListingLink = utils.composeBusinessUrl(
    industry,
    slugName,
    type,
  );

  return (
    <div className={classes}>
      <div className="listing-card__content">
        <div className="listing-card__content__top">
          <StatusBadge isNew={isNewListing(createdAt)} />
          <Link
            className="listing-card__content__top__title"
            to={redirectionListingLink}
          >
            {listingTitle}
          </Link>
          <ListingLocation
            to={redirectionListingLink}
            industry={industry}
            location={location}
            dealLocation={dealLocation}
          />
          <ListingPrices
            className={classNames({
              'premium-listing-prices': isListingPremium,
            })}
            askingPrice={askingPriceSelect}
            amount={amount}
            amountFrom={amountFrom}
            amountTo={amountTo}
            revenue={revenue}
            EBITDA={EBITDA}
            averageStockValue={averageStockValue}
            stockAtValue={stockAtValue}
            currency={currency}
            amountRequiredVisibleInfo={amountRequiredVisibleInfo}
            amountFromRequiredVisibleInfo={amountFromRequiredVisibleInfo}
            amountToRequiredVisibleInfo={amountToRequiredVisibleInfo}
            revenueRequiredVisibleInfo={revenueRequiredVisibleInfo}
            EBITDARequiredVisibleInfo={EBITDARequiredVisibleInfo}
            averageStockValueRequiredVisibleInfo={
              averageStockValueRequiredVisibleInfo
            }
          />
        </div>
        <Link
          className="listing-card__content__description"
          to={redirectionListingLink}
        >
          {businessDescription}
        </Link>

        <ListingActions listing={listing} onWatchlisted={onWatchlisted} />
      </div>

      <ListingCardThumbnail
        to={redirectionListingLink}
        gallery={gallery}
        firmLogo={firmLogo}
        isPremium={isListingPremium}
        shouldLazyLoad={false}
      />
    </div>
  );
};

export default ListingCard;
